import { Injectable } from "@angular/core";
import { ShareDataService } from "../../providers/sharedata.service";
import { LocalStoreManager } from "../../services/local-store-manager.service";

@Injectable()
export class LoginService {
  constructor(private share: ShareDataService, private storage: LocalStoreManager) {
  }
  Login() {
    this.share.loginuser = this.storage.getData('user');
    if (!this.share.waiterFactor)
      this.share.New_waiterFactor();
    //if ((this.share.lastUrl === '/ordermanagement' || !this.share.setting?.systemLayer?.hasTabletOrder) && !this.share.setting?.systemLayer?.isDigitalAlbum) {
    //this.router.navigate(['ordermanagement']);
    //return;
    //}
    //if (this.share.setting && this.share.setting.showTablesPage === 0 && this.share.setting?.systemLayer?.hasTabletOrder) {
    //  this.share.selectedGroupIndex = (!this.share.loginuser.default_Group || this.share.loginuser.default_Group === 0) ? 0 : this.share.loginuser.default_Group - 1;
    //  this.router.navigate(['table']);
    //  return;
    //}
    //if (this.share.setting && this.share.setting.showTablesPage !== 0 && this.share.setting?.systemLayer?.hasTabletOrder) {
    //  this.router.navigate(['waiterorder']);
    //  return true;
    //}
  }
}
